import React from "react";

import DangerousHTML from "dangerous-html/react";
import { Helmet } from "react-helmet";

import Navbar from "../components/navbar";
import GalleryCard3 from "../components/gallery-card3";
import FAQ from "../components/f-a-q";
import Message from "../components/message";
import "./home.css";

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>ProSnapAI</title>
        <meta property="og:title" content="ProSnapAI" />
      </Helmet>
      <Navbar rootClassName="navbar-root-class-name"></Navbar>
      <section className="home-section">
        <div className="home-hero">
          <div className="home-content">
            <main className="home-main">
              <header className="home-header">
                <h1 className="home-heading">
                  Transforming Your Vision into Stunning Reality
                </h1>
                <span className="home-caption">
                  Your vision, our expertise, stunning results
                </span>
              </header>
              <div className="home-buttons">
                <div className="home-get-started button">
                  <span className="home-text">Get started</span>
                </div>
              </div>
            </main>
          </div>
          <img
            alt="image"
            src="/playground_assets/logo_prosnapai-300h.png"
            className="home-image"
          />
        </div>
      </section>
      <section className="home-section1">
        <h2 className="home-text02">Various Stylish AI Generated Images</h2>
        <span className="home-caption1">
          At ProSnapAI, we&apos;re harnessing the power of AI to create
          personalized, stunning images for our users. Whether you&apos;re a
          professional photographer or just looking to capture a special moment,
          our AI technology can help you create the perfect image in any style.
        </span>
        <div className="home-features">
          <header className="home-feature feature feature-active">
            <h3 className="home-text03">AI Avatar</h3>
          </header>
          <header className="feature home-feature1">
            <h3 className="home-text04">Close-up</h3>
          </header>
          <header className="feature home-feature2">
            <h3 className="home-text05">
              <span className="home-text06">Portrait</span>
              <br></br>
            </h3>
          </header>
        </div>
        <div className="home-container1">
          <GalleryCard3 rootClassName="rootClassName"></GalleryCard3>
          <GalleryCard3
            image_src="https://images.unsplash.com/photo-1501127122-f385ca6ddd9d?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDExfHxtaW5pbWFsaXNtJTIwaG9tZXxlbnwwfHx8fDE2MjY0NDg1Mjc&amp;ixlib=rb-1.2.1&amp;h=1000"
            rootClassName="rootClassName1"
          ></GalleryCard3>
          <GalleryCard3
            image_src="https://images.unsplash.com/photo-1467043153537-a4fba2cd39ef?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDR8fG1pbmltYWxpc20lMjBob21lfGVufDB8fHx8MTYyNjQ0ODUyNw&amp;ixlib=rb-1.2.1&amp;h=1000"
            rootClassName="rootClassName3"
          ></GalleryCard3>
          <GalleryCard3
            image_src="https://images.unsplash.com/photo-1531829039722-d3fb3e705a4b?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDE4fHxtaW5pbWFsaXNtJTIwaG9tZXxlbnwwfHx8fDE2MjY0NDg1Mjc&amp;ixlib=rb-1.2.1&amp;h=1000"
            rootClassName="rootClassName2"
          ></GalleryCard3>
        </div>
      </section>
      <section className="home-section2">
        <section className="home-note">
          <div className="home-content01">
            <main className="home-main1">
              <main className="home-heading01">
                <header className="home-header01">
                  <h2 className="section-heading">
                    How you can get your own personalized images
                  </h2>
                  <p className="section-description">
                    With ProSnapAI, you can create stunning, personalized images
                    that reflect your unique style and preferences. Here&apos;s
                    how:
                  </p>
                </header>
                <div className="home-checkmarks">
                  <div className="home-mark">
                    <div className="home-icon">
                      <svg viewBox="0 0 1024 1024" className="home-icon01">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                    </div>
                    <p className="home-label">Create account and login</p>
                  </div>
                  <div className="home-mark01">
                    <div className="home-icon03">
                      <svg viewBox="0 0 1024 1024" className="home-icon04">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                    </div>
                    <p className="home-label01">Choose your preference</p>
                  </div>
                  <div className="home-mark02">
                    <div className="home-icon06">
                      <svg viewBox="0 0 1024 1024" className="home-icon07">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                    </div>
                    <p className="home-label02">
                      <span>Upload your pictures (minimum 30)</span>
                      <br></br>
                    </p>
                  </div>
                  <div className="home-mark03">
                    <div className="home-icon09">
                      <svg viewBox="0 0 1024 1024" className="home-icon10">
                        <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                      </svg>
                    </div>
                    <p className="home-label03">
                      <span>Make payment and submit request</span>
                      <br></br>
                    </p>
                  </div>
                </div>
              </main>
            </main>
            <p className="home-paragraph1 section-description">
              Then wait for 24 hours and your images will be waiting for you in
              your inbox
            </p>
            <div className="home-get-started2 button">
              <span className="home-text12">Get started</span>
            </div>
          </div>
          <div className="home-image1">
            <img
              alt="image"
              src="https://images.unsplash.com/photo-1677211034919-97b87761d00b?ixid=Mnw5MTMyMXwwfDF8YWxsfDE1fHx8fHx8Mnx8MTY3NzIzMjk1NA&amp;ixlib=rb-4.0.3&amp;w=500"
              className="home-image2"
            />
          </div>
        </section>
      </section>
      <section className="home-section3">
        <header className="home-header02">
          <header className="home-left">
            <h2 className="section-heading">Why us?</h2>
          </header>
          <div className="home-right">
            <p className="home-paragraph2 section-description">
              At ProSnapAI, we&apos;re committed to making personalized,
              AI-generated images accessible to everyone. With our easy-to-use
              platform, anyone can create a stunning image that reflects their
              unique vision and style.
            </p>
          </div>
        </header>
        <main className="home-cards">
          <section className="home-card">
            <div className="home-icon12">
              <img
                alt="image"
                src="/playground_assets/group%201317-200h.png"
                className="home-icon13"
              />
            </div>
            <main className="home-content02">
              <h1 className="home-header03">Personalization</h1>
              <p className="home-description">
                You can create personalized images that reflect your unique
                style and preferences.
              </p>
            </main>
          </section>
          <section className="home-card01">
            <div className="home-icon14">
              <img
                alt="image"
                src="/playground_assets/group%201316-200w.png"
                className="home-icon15"
              />
            </div>
            <main className="home-content03">
              <h1 className="home-header04">Easy Payment</h1>
              <p className="home-description1">
                {" "}
                payments should be easy and hassle-free. That&apos;s why we
                offer UPI payment option.
              </p>
            </main>
          </section>
          <section className="home-card02">
            <div className="home-icon16">
              <img
                alt="image"
                src="/playground_assets/group%201314-200h.png"
                className="home-icon17"
              />
            </div>
            <main className="home-content04">
              <h1 className="home-header05">Trusted Network</h1>
              <p className="home-description2">
                we value our users&apos; trust and work hard to maintain a safe
                and secure network.
              </p>
            </main>
          </section>
        </main>
      </section>
      <section className="home-section4">
        <main className="home-pricing">
          <header className="home-header06">
            <h2 className="section-heading home-heading04">PRICING</h2>
            <p className="home-paragraph3 section-description">
              We offer flexible pricing options to suit your needs.
            </p>
          </header>
          <div className="home-plans-container">
            <main className="home-plans">
              <div className="home-plan">
                <div className="home-details">
                  <div className="home-header07">
                    <label className="home-name">Basic</label>
                    <div className="home-pricing1">
                      <h1 className="home-price">₹250</h1>
                    </div>
                  </div>
                </div>
                <div className="home-buy-details">
                  <div className="home-buy button">
                    <span className="home-text13">
                      <span>Go for Basic</span>
                      <br></br>
                    </span>
                  </div>
                  <div className="home-features1">
                    <span className="home-heading05">You will get</span>
                    <div className="home-list">
                      <div className="home-mark04">
                        <div className="home-icon18">
                          <svg viewBox="0 0 1024 1024" className="home-icon19">
                            <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                          </svg>
                        </div>
                        <label className="home-label04">
                          50 personalized photos
                        </label>
                      </div>
                      <div className="home-mark05">
                        <div className="home-icon21">
                          <svg viewBox="0 0 1024 1024" className="home-icon22">
                            <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                          </svg>
                        </div>
                        <label className="home-label05">5  Bonus photos</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="home-plan1">
                <div className="home-details1">
                  <div className="home-header08">
                    <label className="home-name1">Pro</label>
                    <div className="home-pricing2">
                      <h1 className="home-price1">₹500</h1>
                    </div>
                  </div>
                </div>
                <div className="home-buy-details1">
                  <div className="home-buy1 button">
                    <span className="home-text16">
                      <span>Go for Pro</span>
                      <br></br>
                    </span>
                  </div>
                  <div className="home-features2">
                    <span className="home-heading06">You will get</span>
                    <div className="home-list1">
                      <div className="home-mark06">
                        <div className="home-icon24">
                          <svg viewBox="0 0 1024 1024" className="home-icon25">
                            <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                          </svg>
                        </div>
                        <label className="home-label06">
                          100  personalized photos
                        </label>
                      </div>
                      <div className="home-mark07">
                        <div className="home-icon27">
                          <svg viewBox="0 0 1024 1024" className="home-icon28">
                            <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                          </svg>
                        </div>
                        <label className="home-label07">10 bonus</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="home-plan2">
                <div className="home-details2">
                  <div className="home-header09">
                    <label className="home-name2">
                      <span>Premium</span>
                      <br></br>
                    </label>
                    <div className="home-pricing3">
                      <span className="home-price2">
                        <span>₹800</span>
                        <br></br>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="home-buy-details2">
                  <div className="home-buy2 button">
                    <span className="home-text23">
                      <span>Go for Premium</span>
                      <br></br>
                    </span>
                  </div>
                  <div className="home-features3">
                    <span className="home-heading07">You will get</span>
                    <div className="home-list2">
                      <div className="home-mark08">
                        <div className="home-icon30">
                          <svg viewBox="0 0 1024 1024" className="home-icon31">
                            <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                          </svg>
                        </div>
                        <label className="home-label08">
                          200 personlized photos
                        </label>
                      </div>
                      <div className="home-mark09">
                        <div className="home-icon33">
                          <svg viewBox="0 0 1024 1024" className="home-icon34">
                            <path d="M384 690l452-452 60 60-512 512-238-238 60-60z"></path>
                          </svg>
                        </div>
                        <label className="home-label09">20 bonus</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
            <p className="home-paragraph4 section-description">
              <span>
                Want customized pictures
                <span
                  dangerouslySetInnerHTML={{
                    __html: " ",
                  }}
                />
              </span>
              <span className="home-text27">Learn More.</span>
            </p>
          </div>
        </main>
      </section>
      <section className="home-section5">
        <header className="home-header10">
          <h2 className="home-heading08 section-heading">
            What users say about us
          </h2>
        </header>
        <main className="home-cards1">
          <div className="home-container2">
            <section className="home-card03">
              <main className="home-content05">
                <p className="home-quote">
                  &quot;I was blown away by the quality of the AI-generated
                  images I created with ProSnapAI. The personalization options
                  really allowed me to bring my vision to life.&quot;
                </p>
                <div className="home-author">
                  <img
                    alt="image"
                    src="https://images.unsplash.com/photo-1464746133101-a2c3f88e0dd9?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDI4fHxtYW58ZW58MHx8fHwxNjc3MjM3NjQ1&amp;ixlib=rb-4.0.3&amp;w=200"
                    className="home-avatar"
                  />
                  <div className="home-details3">
                    <h1 className="home-author01">Anshul Sharma</h1>
                    <label className="home-position">Designer</label>
                  </div>
                </div>
              </main>
            </section>
            <section className="home-card04">
              <main className="home-content06">
                <p className="home-quote1">
                  &quot;I&apos;ve tried a lot of different AI-generated image
                  tools, but ProSnapAI stands out for its superior technology
                  and exceptional customer service. The results speak for
                  themselves - the images I&apos;ve created with ProSnapAI have
                  exceeded my expectations every time.&quot;
                </p>
                <div className="home-author02">
                  <img
                    alt="image"
                    src="https://images.unsplash.com/photo-1464746133101-a2c3f88e0dd9?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDI4fHxtYW58ZW58MHx8fHwxNjc3MjM3NjQ1&amp;ixlib=rb-4.0.3&amp;w=200"
                    className="home-avatar1"
                  />
                  <div className="home-details4">
                    <h1 className="home-author03">Anshul Sharma</h1>
                    <label className="home-position1">Designer</label>
                  </div>
                </div>
              </main>
            </section>
          </div>
          <div className="home-container3">
            <section className="home-card05">
              <main className="home-content07">
                <p className="home-quote2">
                  &quot;ProSnapAI has completely transformed the way I create
                  content for my social media accounts. The ease of use and
                  variety of options available make it my go-to tool for
                  generating stunning images.&quot;
                </p>
                <div className="home-author04">
                  <img
                    alt="image"
                    src="https://images.unsplash.com/photo-1464746133101-a2c3f88e0dd9?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDI4fHxtYW58ZW58MHx8fHwxNjc3MjM3NjQ1&amp;ixlib=rb-4.0.3&amp;w=200"
                    className="home-avatar2"
                  />
                  <div className="home-details5">
                    <h1 className="home-author05">Anshul Sharma</h1>
                    <label className="home-position2">Designer</label>
                  </div>
                </div>
              </main>
            </section>
            <section className="home-card06">
              <main className="home-content08">
                <p className="home-quote3">
                  &quot;ProSnapAI is a game-changer for anyone who needs to
                  create visual content quickly and easily. The options for
                  customization are endless, and the pricing is very reasonable
                  for the quality of the product.&quot;
                </p>
                <div className="home-author06">
                  <img
                    alt="image"
                    src="https://images.unsplash.com/photo-1464746133101-a2c3f88e0dd9?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDI4fHxtYW58ZW58MHx8fHwxNjc3MjM3NjQ1&amp;ixlib=rb-4.0.3&amp;w=200"
                    className="home-avatar3"
                  />
                  <div className="home-details6">
                    <h1 className="home-author07">Anshul Sharma</h1>
                    <label className="home-position3">Designer</label>
                  </div>
                </div>
              </main>
            </section>
          </div>
          <div className="home-container4">
            <section className="home-card07">
              <main className="home-content09">
                <p className="home-quote4">
                  &quot;As someone who doesn&apos;t have a lot of experience
                  with AI technology, I was pleasantly surprised by how easy it
                  was to create professional-quality images with ProSnapAI. The
                  platform is intuitive and user-friendly, and the support team
                  is always available to answer any questions.&quot;
                </p>
                <div className="home-author08">
                  <img
                    alt="image"
                    src="https://images.unsplash.com/photo-1464746133101-a2c3f88e0dd9?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDI4fHxtYW58ZW58MHx8fHwxNjc3MjM3NjQ1&amp;ixlib=rb-4.0.3&amp;w=200"
                    className="home-avatar4"
                  />
                  <div className="home-details7">
                    <h1 className="home-author09">Anshul Sharma</h1>
                    <label className="home-position4">Designer</label>
                  </div>
                </div>
              </main>
            </section>
            <section className="home-card08">
              <main className="home-content10">
                <p className="home-quote5">
                  &quot;I was blown away by the quality of the AI-generated
                  images I created with ProSnapAI. The personalization options
                  really allowed me to bring my vision to life.&quot;
                </p>
                <div className="home-author10">
                  <img
                    alt="image"
                    src="https://images.unsplash.com/photo-1464746133101-a2c3f88e0dd9?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDI4fHxtYW58ZW58MHx8fHwxNjc3MjM3NjQ1&amp;ixlib=rb-4.0.3&amp;w=200"
                    className="home-avatar5"
                  />
                  <div className="home-details8">
                    <h1 className="home-author11">Anshul Sharma</h1>
                    <label className="home-position5">Designer</label>
                  </div>
                </div>
              </main>
            </section>
          </div>
        </main>
        <div className="home-view-more">
          <p className="home-text28">View more</p>
        </div>
      </section>
      <section className="home-section6">
        <header className="home-header11">
          <h2 className="home-heading09 section-heading">We’re ProSnapAI</h2>
        </header>
        <main className="home-cards2">
          <section className="home-card09">
            <main className="home-content11">
              <img
                alt="image"
                src="/playground_assets/logo_prosnapai-300h.png"
                className="home-image3"
              />
              <header className="home-header12">
                <h1 className="home-header13">Ayush Yadav</h1>
              </header>
              <p className="home-description3">Founder</p>
              <div className="home-social-bar">
                <svg
                  viewBox="0 0 950.8571428571428 1024"
                  className="home-icon36"
                >
                  <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                </svg>
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="home-icon38"
                >
                  <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
                </svg>
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="home-icon40"
                >
                  <path d="M585.143 857.143c-5.714-33.143-27.429-147.429-80-284.571-0.571 0-1.714 0.571-2.286 0.571 0 0-222.286 77.714-294.286 234.286-3.429-2.857-8.571-6.286-8.571-6.286 65.143 53.143 148 85.714 238.857 85.714 52 0 101.143-10.857 146.286-29.714zM479.429 510.286c-9.143-21.143-19.429-42.286-30.286-63.429-193.143 57.714-378.286 53.143-384.571 53.143-0.571 4-0.571 8-0.571 12 0 96 36.571 184 96 250.286v0c102.286-182.286 304.571-247.429 304.571-247.429 5.143-1.714 10.286-2.857 14.857-4.571zM418.286 389.143c-65.143-115.429-134.286-209.143-139.429-216-104.571 49.143-182.286 145.714-206.857 261.714 9.714 0 166.286 1.714 346.286-45.714zM809.143 571.429c-8-2.286-112.571-35.429-233.714-16.571 49.143 135.429 69.143 245.714 73.143 268 84-56.571 143.429-146.857 160.571-251.429zM349.143 148c-0.571 0-0.571 0-1.143 0.571 0 0 0.571-0.571 1.143-0.571zM686.286 230.857c-65.714-58.286-152.571-93.714-247.429-93.714-30.286 0-60 4-88.571 10.857 5.714 7.429 76.571 100.571 140.571 218.286 141.143-52.571 194.286-133.714 195.429-135.429zM813.714 508c-1.143-88.571-32.571-170.286-85.143-234.286-1.143 1.143-61.143 88-209.143 148.571 8.571 17.714 17.143 36 25.143 54.286 2.857 6.286 5.143 13.143 8 19.429 129.143-16.571 256.571 11.429 261.143 12zM877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
                </svg>
                <svg viewBox="0 0 1024 1024" className="home-icon42">
                  <path d="M1013.8 307.2c0 0-10-70.6-40.8-101.6-39-40.8-82.6-41-102.6-43.4-143.2-10.4-358.2-10.4-358.2-10.4h-0.4c0 0-215 0-358.2 10.4-20 2.4-63.6 2.6-102.6 43.4-30.8 31-40.6 101.6-40.6 101.6s-10.2 82.8-10.2 165.8v77.6c0 82.8 10.2 165.8 10.2 165.8s10 70.6 40.6 101.6c39 40.8 90.2 39.4 113 43.8 82 7.8 348.2 10.2 348.2 10.2s215.2-0.4 358.4-10.6c20-2.4 63.6-2.6 102.6-43.4 30.8-31 40.8-101.6 40.8-101.6s10.2-82.8 10.2-165.8v-77.6c-0.2-82.8-10.4-165.8-10.4-165.8zM406.2 644.8v-287.8l276.6 144.4-276.6 143.4z"></path>
                </svg>
              </div>
            </main>
          </section>
          <section className="home-card10">
            <main className="home-content12">
              <img
                alt="image"
                src="/playground_assets/logo_prosnapai-300h.png"
                className="home-image4"
              />
              <header className="home-header14">
                <h1 className="home-header15">Anshul Sharma</h1>
              </header>
              <p className="home-description4">
                <span>Designer &amp; Developer</span>
                <br></br>
              </p>
              <div className="home-social-bar1">
                <svg
                  viewBox="0 0 950.8571428571428 1024"
                  className="home-icon44"
                >
                  <path d="M925.714 233.143c-25.143 36.571-56.571 69.143-92.571 95.429 0.571 8 0.571 16 0.571 24 0 244-185.714 525.143-525.143 525.143-104.571 0-201.714-30.286-283.429-82.857 14.857 1.714 29.143 2.286 44.571 2.286 86.286 0 165.714-29.143 229.143-78.857-81.143-1.714-149.143-54.857-172.571-128 11.429 1.714 22.857 2.857 34.857 2.857 16.571 0 33.143-2.286 48.571-6.286-84.571-17.143-148-91.429-148-181.143v-2.286c24.571 13.714 53.143 22.286 83.429 23.429-49.714-33.143-82.286-89.714-82.286-153.714 0-34.286 9.143-65.714 25.143-93.143 90.857 112 227.429 185.143 380.571 193.143-2.857-13.714-4.571-28-4.571-42.286 0-101.714 82.286-184.571 184.571-184.571 53.143 0 101.143 22.286 134.857 58.286 41.714-8 81.714-23.429 117.143-44.571-13.714 42.857-42.857 78.857-81.143 101.714 37.143-4 73.143-14.286 106.286-28.571z"></path>
                </svg>
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="home-icon46"
                >
                  <path d="M585.143 512c0-80.571-65.714-146.286-146.286-146.286s-146.286 65.714-146.286 146.286 65.714 146.286 146.286 146.286 146.286-65.714 146.286-146.286zM664 512c0 124.571-100.571 225.143-225.143 225.143s-225.143-100.571-225.143-225.143 100.571-225.143 225.143-225.143 225.143 100.571 225.143 225.143zM725.714 277.714c0 29.143-23.429 52.571-52.571 52.571s-52.571-23.429-52.571-52.571 23.429-52.571 52.571-52.571 52.571 23.429 52.571 52.571zM438.857 152c-64 0-201.143-5.143-258.857 17.714-20 8-34.857 17.714-50.286 33.143s-25.143 30.286-33.143 50.286c-22.857 57.714-17.714 194.857-17.714 258.857s-5.143 201.143 17.714 258.857c8 20 17.714 34.857 33.143 50.286s30.286 25.143 50.286 33.143c57.714 22.857 194.857 17.714 258.857 17.714s201.143 5.143 258.857-17.714c20-8 34.857-17.714 50.286-33.143s25.143-30.286 33.143-50.286c22.857-57.714 17.714-194.857 17.714-258.857s5.143-201.143-17.714-258.857c-8-20-17.714-34.857-33.143-50.286s-30.286-25.143-50.286-33.143c-57.714-22.857-194.857-17.714-258.857-17.714zM877.714 512c0 60.571 0.571 120.571-2.857 181.143-3.429 70.286-19.429 132.571-70.857 184s-113.714 67.429-184 70.857c-60.571 3.429-120.571 2.857-181.143 2.857s-120.571 0.571-181.143-2.857c-70.286-3.429-132.571-19.429-184-70.857s-67.429-113.714-70.857-184c-3.429-60.571-2.857-120.571-2.857-181.143s-0.571-120.571 2.857-181.143c3.429-70.286 19.429-132.571 70.857-184s113.714-67.429 184-70.857c60.571-3.429 120.571-2.857 181.143-2.857s120.571-0.571 181.143 2.857c70.286 3.429 132.571 19.429 184 70.857s67.429 113.714 70.857 184c3.429 60.571 2.857 120.571 2.857 181.143z"></path>
                </svg>
                <svg
                  viewBox="0 0 877.7142857142857 1024"
                  className="home-icon48"
                >
                  <path d="M585.143 857.143c-5.714-33.143-27.429-147.429-80-284.571-0.571 0-1.714 0.571-2.286 0.571 0 0-222.286 77.714-294.286 234.286-3.429-2.857-8.571-6.286-8.571-6.286 65.143 53.143 148 85.714 238.857 85.714 52 0 101.143-10.857 146.286-29.714zM479.429 510.286c-9.143-21.143-19.429-42.286-30.286-63.429-193.143 57.714-378.286 53.143-384.571 53.143-0.571 4-0.571 8-0.571 12 0 96 36.571 184 96 250.286v0c102.286-182.286 304.571-247.429 304.571-247.429 5.143-1.714 10.286-2.857 14.857-4.571zM418.286 389.143c-65.143-115.429-134.286-209.143-139.429-216-104.571 49.143-182.286 145.714-206.857 261.714 9.714 0 166.286 1.714 346.286-45.714zM809.143 571.429c-8-2.286-112.571-35.429-233.714-16.571 49.143 135.429 69.143 245.714 73.143 268 84-56.571 143.429-146.857 160.571-251.429zM349.143 148c-0.571 0-0.571 0-1.143 0.571 0 0 0.571-0.571 1.143-0.571zM686.286 230.857c-65.714-58.286-152.571-93.714-247.429-93.714-30.286 0-60 4-88.571 10.857 5.714 7.429 76.571 100.571 140.571 218.286 141.143-52.571 194.286-133.714 195.429-135.429zM813.714 508c-1.143-88.571-32.571-170.286-85.143-234.286-1.143 1.143-61.143 88-209.143 148.571 8.571 17.714 17.143 36 25.143 54.286 2.857 6.286 5.143 13.143 8 19.429 129.143-16.571 256.571 11.429 261.143 12zM877.714 512c0 242.286-196.571 438.857-438.857 438.857s-438.857-196.571-438.857-438.857 196.571-438.857 438.857-438.857 438.857 196.571 438.857 438.857z"></path>
                </svg>
                <svg viewBox="0 0 1024 1024" className="home-icon50">
                  <path d="M1013.8 307.2c0 0-10-70.6-40.8-101.6-39-40.8-82.6-41-102.6-43.4-143.2-10.4-358.2-10.4-358.2-10.4h-0.4c0 0-215 0-358.2 10.4-20 2.4-63.6 2.6-102.6 43.4-30.8 31-40.6 101.6-40.6 101.6s-10.2 82.8-10.2 165.8v77.6c0 82.8 10.2 165.8 10.2 165.8s10 70.6 40.6 101.6c39 40.8 90.2 39.4 113 43.8 82 7.8 348.2 10.2 348.2 10.2s215.2-0.4 358.4-10.6c20-2.4 63.6-2.6 102.6-43.4 30.8-31 40.8-101.6 40.8-101.6s10.2-82.8 10.2-165.8v-77.6c-0.2-82.8-10.4-165.8-10.4-165.8zM406.2 644.8v-287.8l276.6 144.4-276.6 143.4z"></path>
                </svg>
              </div>
            </main>
          </section>
        </main>
      </section>
      <section className="home-section7">
        <header className="home-header16">
          <h2 className="home-heading10 section-heading">
            Frequently asked questions
          </h2>
        </header>
        <main className="home-accordion">
          <FAQ rootClassName="f-a-q-root-class-name"></FAQ>
        </main>
      </section>
      <footer className="home-footer">
        <div className="home-content13">
          <main className="home-main-content">
            <header className="home-main2">
              <div className="home-header17">
                <img
                  alt="image"
                  src="/playground_assets/logo_prosnapai-300h.png"
                  className="home-branding"
                />
                <span className="home-text31">
                  Your vision, our expertise, stunning results
                </span>
              </div>
              <div className="home-socials">
                <a
                  href="https://example.com"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="home-link"
                >
                  <img
                    alt="image"
                    src="/playground_assets/linkedin-200h.png"
                    className="social"
                  />
                </a>
              </div>
            </header>
          </main>
          <Message></Message>
          <section className="home-copyright">
            <span className="home-text32">
              © 2022 ProsnapAI. All Rights Reserved.
            </span>
          </section>
        </div>
      </footer>
      <div>
        <DangerousHTML
          html={`<script>
    /*
Accordion - Code Embed
*/

/* listenForUrlChangesAccordion() makes sure that if you changes pages inside your app,
the Accordions will still work*/

const listenForUrlChangesAccordion = () => {
      let url = location.href;
      document.body.addEventListener(
        "click",
        () => {
          requestAnimationFrame(() => {
            if (url !== location.href) {
              runAccordionCodeEmbed();
              url = location.href;
            }
          });
        },
        true
      );
    };


const runAccordionCodeEmbed = () => {
    const accordionContainers = document.querySelectorAll('[data-role="accordion-container"]'); // All accordion containers
    const accordionContents = document.querySelectorAll('[data-role="accordion-content"]'); // All accordion content
    const accordionIcons = document.querySelectorAll('[data-role="accordion-icon"]'); // All accordion icons

    accordionContents.forEach((accordionContent) => {
        accordionContent.style.display = "none"; //Hides all accordion contents
    });

    accordionContainers.forEach((accordionContainer, index) => {
        accordionContainer.addEventListener("click", () => {
            accordionContents.forEach((accordionContent) => {
            accordionContent.style.display = "none"; //Hides all accordion contents
            });

            accordionIcons.forEach((accordionIcon) => {
                accordionIcon.style.transform = "rotate(0deg)"; // Resets all icon transforms to 0deg (default)
            });

            accordionContents[index].style.display = "flex"; // Shows accordion content
            accordionIcons[index].style.transform = "rotate(180deg)"; // Rotates accordion icon 180deg
        });
    });
}

runAccordionCodeEmbed()
listenForUrlChangesAccordion()

/*
Here's what the above is doing:
    1. Selects all accordion containers, contents, and icons
    2. Hides all accordion contents
    3. Adds an event listener to each accordion container
    4. When an accordion container is clicked, it:
        - Hides all accordion contents
        - Resets all icon transforms to 0deg (default)
        - Checks if this container has class "accordion-open"
            - If it does, it removes class "accordion-open"
            - If it doesn't, it:
                - Removes class "accordion-open" from all containers
                - Adds class "accordion-open" to this container
                - Shows accordion content
                - Rotates accordion icon 180deg
*/
</script>`}
        ></DangerousHTML>
      </div>
    </div>
  );
};

export default Home;
